import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { CalendarOptions } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../shared/data/data.service';
import { cilAlignCenter } from '@coreui/icons';
import { tourList,tourDateList, imgList, discountList } from '../shared/models/models';
import { Element } from '@angular/compiler';
import { vCalendar} from '../shared/vcalendar/vcalendar';
import { formatCurrency } from '@angular/common';
import { NgImageSliderComponent } from 'ng-image-slider';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar } from '@fullcalendar/core';


@Component({
  selector: 'app-itinerary',
  templateUrl: './itinerary.component.html',
  styleUrls: ['./itinerary.component.scss']
})




export class ItineraryComponent implements OnInit{
  @ViewChild("dayCalendar",{static:false})
  calendarComponent: FullCalendarComponent;

  @ViewChild("yearCalendar",{static:false})
  calendarComponentYear: FullCalendarComponent;

  @ViewChild('sliderWrapper', { static: false }) sliderWrapper: ElementRef;
  @ViewChild('ratioImg', { static: false }) ratioImg!: ElementRef<HTMLImageElement>;

  calendarApi : Calendar;

  constructor(private route: ActivatedRoute, public data: DataService, categoryData: DataService, private imgList: DataService, private holidayList: DataService) {}

  
  public calendarPlugins = [dayGridPlugin,  interactionPlugin];
  public calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin, interactionPlugin],
    eventClick: this.handleDateClick.bind(this), 
    events: [],
    locale: 'zh-tw',
    headerToolbar: {left:'prev', center:'title', right:'next'},
    allDayText: '',
    buttonText: {today: '今天'},
    height: '700px',
    aspectRatio:1.5,
    
  }

  public calendarOptionsList: CalendarOptions = {
    initialView: 'listYear',
    plugins: [dayGridPlugin, listPlugin, interactionPlugin],
    eventClick: this.YearDateClick.bind(this), 
    events: [
      
    ],
    locale: 'zh-tw',
    headerToolbar: {left:'prev', center:'title', right:'next'},
    allDayText: '',
    buttonText: {today: '今天', list: '年'},
    height: '700px',
    aspectRatio:1.5
  }
  itinCode='';
  public TourList: Array<tourList> = [];
  public TourDateList: Array<tourDateList> = [];
  public tourPriceList: Array<tourDateList> = [];
  public imgFileList: Array<imgList> = [];
  public imgCollection: Array<object> = [];
  public discountList: Array<discountList> = [];
  totalTour=0;
  totalTourDate=0;
  adtPrice='';
  uchPrice='';
  chdPrice='';
  infPrice='';
  snrPrice='';
  adtTax='';
  chdTax='';
  infTax='';
  tourCode='未選擇日期';
  transportation='未選擇日期';
  otherChargeAmount=0;
  adt=2;
  uch=0;
  chd=0;
  chooseDate='';
  agreement=false;
  initialDate='';
  newEvents:Array<any>  = [];
  listEvents:Array<any> = [];
  lblDiscount = '';
  avaSeat = '';

  handleDateClick(arg:any) {
    console.log("Selected Date:", arg.event.startStr );
    console.log("Tour Code:", arg.event.extendedProps.tourCode);

    let tourCode = arg.event.extendedProps.tourCode;
    this.tourPriceList = this.TourDateList.filter(tourData=> tourData.tourCode === tourCode);
    this.adtPrice = this.tourPriceList[0].adtPrice.replace('.00','');
    this.uchPrice = this.tourPriceList[0].uchPrice.replace('.00','');
    this.chdPrice = this.tourPriceList[0].chdPrice.replace('.00','');
    this.snrPrice = this.tourPriceList[0].snrPrice.replace('.00','');
    this.adtTax = this.tourPriceList[0].adtTax.replace('.00','');
    this.chdTax = this.tourPriceList[0].chdTax.replace('.00','');
    this.infTax = this.tourPriceList[0].infTax.replace('.00','');
    this.avaSeat = this.tourPriceList[0].avaSeatQty;

    this.tourCode = this.tourPriceList[0].tourCode;
    this.transportation = this.tourPriceList[0].transportation; 
    this.otherChargeAmount=parseInt(this.tourPriceList[0].otherChargeAmount);
    this.chooseDate = "已選擇日期:"+arg.event.startStr;
    this.calendarApi = this.calendarComponent.getApi();


    console.log('arg:', this.newEvents);
    if (this.newEvents[this.newEvents.length-1].title == "已選取") {
      this.newEvents[this.newEvents.length-1].start=arg.event.startStr;
    } else {
      this.newEvents.push({title: '已選取', start: arg.event.startStr,  rendering:'background', color:'lightblue', textColor:'black', overLap:true, allDay:true}); 
    }

  //  console.log('newevents:', this.newEvents);
  //  this.calendarApi.addEvent(this.newEvents);
    this.calendarApi.removeAllEventSources();
    this.calendarApi.addEventSource(this.newEvents);
    this.calendarApi.refetchEvents();

    this.calendarApi.render();

//    alert("已選擇日期："+arg.event.startStr+"\r\n團編號："+this.tourCode);

    console.log('arg:', this.newEvents);

 //   if ( arg.element.classList.contain("fc-day-sun") &&  arg.element.classList.contain("fc-day-future")) 
//      arg.element.style.backgroundColor='red';

    this.discountList = [];
    this.data.getDiscountList(this.tourCode).subscribe((discountData: any) => {
      console.log("discountData:", discountData);
      for (let i=0; i<discountData.length; i++) {
        if (discountData[i].discountAmount!="0")
          this.discountList.push(discountData[i]);
      }
      this.lblDiscount = "其他優惠";
    });

//    window.location.href="/itinerary?seldate="+arg.event.startStr;

  }


YearDateClick(arg:any): void {
  console.log("date click:", arg.event.startStr);
  this.calendarApi= this.calendarComponent.getApi();
  this.calendarApi.gotoDate(arg.event.startStr);
  this.handleDateClick(arg);
  
}

ngOnInit(): void {
  this.route.queryParams
  .subscribe(params => {
    console.log(params);
    this.itinCode = params['itinCode'];
  });


  this.getTour(this.itinCode);
  this.getTourDate(this.itinCode);
  this.priceInputBtn();
  this.getTourImage();



}

ngAfterViewInit(): void {
  const slider = this.sliderWrapper?.nativeElement;

  if (slider) {
    this.adjustFitBasedOnAspectRatio();
  }

  const ratioImg = this.ratioImg?.nativeElement;
  if (ratioImg) {
    this.adjustSingleFitBasedOnAspectRatio();
  }
}

adjustFitBasedOnAspectRatio(): void {
  console.log("adjustFitBasedOnAspectRatio");

  const slider = document.querySelector('ng-image-slider');
  if (!slider) {
    console.warn('Slider not found');
    return;
  }

  const images: NodeListOf<HTMLImageElement> = slider.querySelectorAll('img.ratio');
  if (!images.length) {
    console.warn('No images with class "ratio" found inside slider');
    return;
  }

  const containerW = 360;
  const containerH = 260;
  const containerAspect = containerW / containerH;

  images.forEach((img: HTMLImageElement) => {
    // Ensure image is loaded before accessing naturalWidth/naturalHeight
    if (!img.complete || !img.naturalWidth || !img.naturalHeight) {
      img.onload = () => this.adjustFitBasedOnAspectRatio(); // Retry when loaded
      return;
    }

    const imageAspect = img.naturalWidth / img.naturalHeight;

    img.style.height = '100%';
    img.style.width = 'auto';
    img.style.objectPosition = 'center';

    if (imageAspect > containerAspect) {
      img.style.objectFit = 'cover';
    } else {
      img.style.objectFit = 'contain';
    }
  });
}

adjustSingleFitBasedOnAspectRatio(): void {
  if (!this.ratioImg || !this.ratioImg.nativeElement) {
    console.warn('Image reference not found');
    return;
  }

  const img = this.ratioImg.nativeElement as HTMLImageElement;

  const containerW = 360;
  const containerH = 260;
  const containerAspect = containerW / containerH;

  if (!img.complete || !img.naturalWidth || !img.naturalHeight) {
    img.onload = () => this.adjustFitBasedOnAspectRatio(); // Retry when loaded
    return;
  }

  const imageAspect = img.naturalWidth / img.naturalHeight;

  img.style.height = '100%';
  img.style.objectPosition = 'center';
  img.style.objectFit = imageAspect > containerAspect ? 'cover' : 'contain';
}

/*
updateMetaTags() {
  // Set page title dynamically
  this.titleService.setTitle('星晨旅遊 Morning Star Travel');

  // Set Open Graph meta tags
  this.metaService.updateTag({ name: 'description', content: '星晨旅遊 Morning Star Travel Des' });
  this.metaService.updateTag({ property: 'og:title', content: '星晨旅遊 Morning Star Travel og' });
  this.metaService.updateTag({ property: 'og:description', content: '星晨旅遊 Morning Star Travel Des og' });
  this.metaService.updateTag({ property: 'og:image', content: 'assets/img/logo.png' });
  this.metaService.updateTag({ property: 'og:url', content: 'https://yourwebsite.com/page' });

  // Set Twitter Card meta tags
  this.metaService.updateTag({ name: 'twitter:title', content: '星晨旅遊 Morning Star Travel tw' });
  this.metaService.updateTag({ name: 'twitter:description', content: '星晨旅遊 Morning Star Travel des tw' });
  this.metaService.updateTag({ name: 'twitter:image', content: 'assets/img/logo.png' });
}
*/

private getTour(itinCode: string) {
  
  let catId = 0;
  let type = '9999';
  this.data.getTourByCategory(catId, type, itinCode).subscribe((tourdata: any) => {
    //        this.totalCategoryData = categorydata.totalData;
//               console.log("sub data:", categorydata);
              this.totalTour = tourdata.length;
              for (let i=0; i<tourdata.length; i++) {
                  this.TourList.push(tourdata[i]);
      //            this.catContent=tourdata[i].catContent;
                  console.log('selfpaidpdf:', this.TourList[i].selfpaidpdf);
        
              };
              this.adtPrice = this.TourList[0].tourPrice.replace('.00','');
              this.uchPrice = this.TourList[0].tourPrice.replace('.00','');
              this.chdPrice = this.TourList[0].tourPrice.replace('.00','');
              this.snrPrice = this.TourList[0].tourPrice.replace('.00','');
              this.infPrice = this.TourList[0].tourPrice.replace('.00','');

          });

  }


  private getTourDate(itinCode: string) {
    let backgroundcolor = 'green';
    let fontcolor='white';
    let initialDateControl = true;
    let isFire = '';


        this.data.getTourDate(itinCode,'I').subscribe((tourdata: any) => {
          //        this.totalCategoryData = categorydata.totalData;
      //               console.log("sub data:", categorydata);

                    this.totalTourDate = tourdata.length;
                    for (let i=0; i<tourdata.length; i++) {
                        this.TourDateList.push(tourdata[i]);
            //            this.catContent=tourdata[i].catContent;
                    };


                    for (let i=0; i<this.TourDateList.length;i++) {
                      isFire = '';
                      if (this.TourDateList[i].avaSeatQty=="A") {
                        backgroundcolor='#EFE405';
                        fontcolor='black';
                      }

                      if (this.TourDateList[i].avaSeatQty!="A" && this.TourDateList[i].avaSeatQty!="0") {
                        backgroundcolor='#300CF5';
                        fontcolor='white';
                      }

                      //將成團
                      if (this.TourDateList[i].avaSeatQty!="A") {
                        if (parseInt(this.TourDateList[i].avaSeatQty)>5) {
                          backgroundcolor='#EFE405';
                          fontcolor='black';
                        }
                        if ((this.TourDateList[i].tourStatus=="G" || this.TourDateList[i].tourStatus == "C") && parseInt(this.TourDateList[i].avaSeatQty)>5) {
                            backgroundcolor='red';
                            fontcolor='white';
                            isFire='<iconify-icon icon="noto-v1:fire" ></iconify-icon>';
                        } else {
                          if (parseInt(this.TourDateList[i].avaSeatQty)<=5) {
                            backgroundcolor='#300CF5';
                            fontcolor='white';
                          }
                        }
                      } else {
                        if (this.TourDateList[i].tourStatus=="G" || this.TourDateList[i].tourStatus=="C") {
                          backgroundcolor='red';
                          fontcolor='white';
                          isFire='<iconify-icon icon="noto-v1:fire" ></iconify-icon>';
                        }
                      }
            
                      if (this.TourDateList[i].avaSeatQty!="0") {
                        // for stella, itinCode = BBEK05P , all A group disable due to insurrance issue
                        console.log('tourCode:', this.TourDateList[i].tourCode.substring(0,7));
                        console.log('A group:', this.TourDateList[i].tourCode.slice(-1));

                        if (this.TourDateList[i].tourCode.substring(0,7) != 'BBEK05P' || this.TourDateList[i].tourCode.slice(-1) != 'A') {
                         this.newEvents.push({title:this.TourDateList[i].tourCode.slice(-1)+'$'+Number(this.TourDateList[i].adtPrice.replace('.00','')).toLocaleString('zh-HK')+'+',start:this.TourDateList[i].departDate, backgroundColor:backgroundcolor, textColor:fontcolor, extendedProps:{tourCode: this.TourDateList[i].tourCode}});
                         this.listEvents.push({title:this.TourDateList[i].tourCode.slice(-1)+'$'+Number(this.TourDateList[i].adtPrice.replace('.00','')).toLocaleString('zh-HK')+'+',start:this.TourDateList[i].departDate, backgroundColor:backgroundcolor, textColor:fontcolor,extendedProps:{tourCode: this.TourDateList[i].tourCode}});
                        }
                        if (initialDateControl) {
                          this.initialDate=this.TourDateList[i].departDate;
                          initialDateControl=false;
                        }
                      }

                    
                    }
                    
                    // import Public Holiday 

                    this.holidayList.getHolidayList().subscribe((holidayData: any) => {
                      console.log("holidayData:", holidayData);
                      for (let i=0; i<holidayData.length; i++) {
                  
                         this.newEvents.push({title: holidayData[i].holiday, start: holidayData[i].holidayDate,  rendering:'background', color:'#FFB6C1', overLap:true, allDay:true}); 
                      };
                     

                      console.log("event holiday push:", this.newEvents);
                      console.log("newEvents:",this.newEvents);
                      this.calendarOptions.events = this.newEvents;
                      this.calendarOptionsList.events = this.listEvents;
                      this.calendarApi = this.calendarComponent.getApi();
                      
                      this.calendarApi.gotoDate(this.initialDate);

                      this.calendarApi = this.calendarComponentYear.getApi();
                      this.calendarApi.gotoDate(this.initialDate);


                      var fillSunday = document.querySelectorAll('td.fc-day.fc-day-sun.fc-day-future.fc-daygrid-day');
                      for (let i=0; i<fillSunday.length; i++) {
                        (fillSunday[i] as HTMLElement).style.backgroundColor='#FFB6C1';
                        (fillSunday[i] as HTMLElement).style.borderColor='white';

                      }

                      console.log('fillSunday:',fillSunday);
                      

                  });

                });
                console.log("tourdate list:",this.TourDateList.length);


        //let newEvents = [{title: '17888',start: '2023-11-18',backgroundColor:'green', textColor:'white'}];



    

     
  }  

dlPDF(brochureLink: string,type: string): void {
   // console.log("URL:",'/assets/static/'+itinCode+'.pdf');
    //window.open('/assets/static/'+itinCode+'.pdf',"_blank","");
    let checkpdf = brochureLink.split(",");
    let selfpaidurl = "/assets/img/selfpaid/"+brochureLink;
    var pdffile= [];
    let pdflink="";
    if (type == 'S')
      window.open(selfpaidurl);
    else {
      if (checkpdf.length > 1) {
        if(checkpdf[0] == ""){
          pdffile = checkpdf[1].split("/");
        }else{
          pdffile = checkpdf[0].split("/");
        }
        pdflink = "/download/assets/static/"+pdffile[pdffile.length-1];
        window.open(pdflink);
      } else {
        let pdffile = brochureLink.split("/");
        pdflink = "/download/assets/static/"+pdffile[pdffile.length-1];
        window.open(pdflink);
      }
    }
}


priceInputBtn(): void {
    // Select all elements with class "price_input-number"
    const inputs = document.querySelectorAll(".price_input-number");


    // Attach event listeners to each input element
     inputs.forEach((input) => {
        const plusButton = input.nextElementSibling;
        const minusButton = input.previousElementSibling;

        plusButton!.addEventListener("click", () => {
          let inputValue = parseInt((input as HTMLInputElement ).value) <=19? parseInt((input as HTMLInputElement).value)+1:20;
          
          (input as HTMLInputElement).value = inputValue.toString();
        });

        minusButton!.addEventListener("click", () => {
          let inputValue = parseInt((input as HTMLInputElement).value);
          if (inputValue > 0) {
            (input as HTMLInputElement).value = (inputValue - 1).toString();
          }
        });
    });
}
loadBookingPage(): void {

  if (this.chooseDate != "") {
    let adt = document.getElementById('txtAdtPrice') as HTMLInputElement;
    let uch = document.getElementById('txtUchPrice') as HTMLInputElement;
    let chd = document.getElementById('txtChdPrice') as HTMLInputElement;

    if (this.agreement) {
      if (this.avaSeat != "A") {
         if (parseInt(adt.value)+parseInt(uch.value)+parseInt(chd.value)<=parseInt(this.avaSeat)) 
            window.location.href='/booking?tourCode='+this.tourCode+'&adt='+adt.value+'&uch='+uch.value+'&chd='+chd.value;
         else
          alert('人數超過可用名額，請重新輸入。');
      
      } else
        window.location.href='/booking?tourCode='+this.tourCode+'&adt='+adt.value+'&uch='+uch.value+'&chd='+chd.value;
    } else
      alert('未接受條款，如接受請在空格內打勾。');
  } else {
    alert('還沒有選擇出發日期！');
  }
}

public getTourImage(): void {
  
  let fileFolder = "https://www.morningstartravel.com.hk/assets/img/tour/"+this.itinCode+"/";
  console.log('File Folder:', fileFolder);
  this.imgList.getImageList(this.itinCode).subscribe((imgdata: any) => {
    for (let i=0; i<imgdata.length; i++) {
        this.imgFileList.push(imgdata[i]);
        this.imgCollection.push({
          image:fileFolder+imgdata[i].tourImageName,
          thumbImage:fileFolder+imgdata[i].tourImageName,
          alt:imgdata[i].tourImageCaption,
          title:imgdata[i].tourImageCaption,
          imageSize:{width:'600', height:'400'}
        });
        console.log("Image File name:", this.imgCollection);
    };
   });
}

public getHoliday(): void {
  
  this.holidayList.getHolidayList().subscribe((holidayData: any) => {
    console.log("holidayData:", holidayData);
    for (let i=0; i<holidayData.length; i++) {

       this.newEvents.push({title: holidayData[i].holiday, start: holidayData[i].holidayDate,  rendering:'background', color:'red', overLap:true, allDay:true}); 
    };
    console.log("event holiday push:", this.newEvents);
    this.calendarOptions.events = this.newEvents;
   });
}

goBack(): void {
  window.history.back();

}

}
